import { useContainerHeight } from '@/shared/lib/react-hooks'
import { Flex } from 'antd'
import { useUnit } from 'effector-react'

import { CONTAINER_HEIGHT } from '../../lib/constants'
import {
  $isChatTouchedByUser,
  $loadingChatInitially,
  FeedbackChatGate,
  chatTouchedByUser,
} from '../../model/feedback-chat.model'
import { FeedbackChatHeader } from '../FeedbackChatHeader'
import { FeedbackChatInput } from '../FeedbackChatInput'
import { FeedbackChatMessageList } from '../FeedbackChatMessageList'
import styles from './styles.module.scss'

type FeedbackChatProps = {
  id: string
}

export function FeedbackChat({ id }: FeedbackChatProps) {
  const {
    ref: listContainerRef,
    containerHeight,
    updateHeight,
  } = useContainerHeight(CONTAINER_HEIGHT)

  const [
    loadingChatInitially,
    isChatTouchedByUser,
    onChatTouchedByUser,
    gateOpened,
  ] = useUnit([
    $loadingChatInitially,
    $isChatTouchedByUser,
    chatTouchedByUser,
    FeedbackChatGate.status,
  ])
  const handleChatTouch = () => {
    if (isChatTouchedByUser || loadingChatInitially || !gateOpened) return
    onChatTouchedByUser()
  }
  return (
    <Flex
      vertical
      className={styles.rootContainer}
      onWheel={handleChatTouch}
      onPointerDown={handleChatTouch}
    >
      <FeedbackChatHeader />
      <FeedbackChatMessageList
        chatId={id}
        listContainerRef={listContainerRef}
        containerHeight={containerHeight}
      />
      <div className={styles.inputContainer}>
        <FeedbackChatInput onHeightChange={updateHeight} />
      </div>
    </Flex>
  )
}
